/**
 * ACCareNotificationChannelService
 * Service for managing per-NotificationType channel toggles
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for notification channel setting operations (getAll + update)
 */
export class ACCareNotificationChannelService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ACCareNotificationChannelService.DEFAULT_SERVICE_PATH,
            basePath: ACCareNotificationChannelService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
ACCareNotificationChannelService.DEFAULT_SERVICE_PATH = 'ac-counselling';
ACCareNotificationChannelService.BASE_PATH = 'api/care-notification-channels';
//# sourceMappingURL=ACCareNotificationChannelService.js.map